import Banner from "../components/Banner";
import { findParentKey, sideItems } from "../config/menus";
import { convertTaskStatusToBannerType, getCurrentPath } from "../utils/helpers";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AppHeader from "../components/Navigation/Header";
import AppFooter from "../components/Navigation/Footer";
import { useGlobalStore } from "../store/useGlobalStore";
import { FloatButton, Layout, Menu } from "antd";

const { Content, Sider } = Layout

function MainLayout(): JSX.Element {
  const tasks = useGlobalStore((state) => state.tasks)
  const [current, setCurrent] = useState([''])
  const [openKey, setOpenKey] = useState<string[]>([])
  const [collapsed, setCollapsed] = useState(false);
  const isDirty = useGlobalStore((state) => state.isDirty)
  const navigate = useNavigate();
  useEffect(() => {
    setCurrent([getCurrentPath()])
  }, [])

  useEffect(() => {
    if (current.length === 1) {
      let openK = findParentKey(current[0])
      if (openK) setOpenKey([openK])
    }
  }, [current])

  const handleNavigate = (e: any) => {
    if (
      isDirty &&
      ["repositories", "pricing-config"].includes(getCurrentPath()) &&
      !["repositories", "pricing-config"].includes(e.key)
    ) {
      console.log("Navigation not allowed");
    } else {
      setCurrent([e.key])
      navigate(e.key)
    }
  }

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault()
        setCollapsed(prevCollapsed => !prevCollapsed)
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleOpenChange = (keys: string[]) => {
    setOpenKey(keys) // Control open keys dynamically for expanded/collapsed menu
  }

  return (
    <Layout className="layout-container">
      <span style={{ position: 'sticky', top: 0, zIndex: 2 }}>
        <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} setCurrent={setCurrent} />
      </span>
      <Layout hasSider>
        <Sider onBreakpoint={(b) => setCollapsed(b)} collapsed={collapsed} className="sidebar" breakpoint="md">
          <Menu
            style={{ borderRight: 0 }}
            selectedKeys={current}
            onClick={(e) => handleNavigate(e)}
            mode="inline"
            items={sideItems}
            openKeys={openKey}
            onOpenChange={handleOpenChange}
          />
        </Sider>
        <Layout>
          {
            tasks.map(t =>
              t.id &&
              <Banner
                text={t.message}
                type={convertTaskStatusToBannerType(t.status)}
              />
            )
          }
          {
            isDirty &&
            <Banner
              text="N'oubliez pas de tout sauvegarder afin que les changements prennent effet.&nbsp;&nbsp;"
            />
          }
          <Content className="dashboard-layout-content">
            <Outlet />
          </Content>
          <AppFooter />
        </Layout>
        <FloatButton.BackTop style={{ bottom: 10 }} className="go-to-top" />
      </Layout>
    </Layout>
  );
}

export default MainLayout;
